import React from "react"

import { AvailableValidationInputValue } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/GenericConditionSectionEditor"
import SelectInput from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/SelectInput"

import useChatBotFlowConstructorStore from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useChatBotFlowConstructorStore"

import { ChatBotFlowBlockRuleValidationType } from "@/protocols/chatBot"

type AttendantUser = { id: number, name: string }

export type ResponsibleAttendantConditionType = Extract<ChatBotFlowBlockRuleValidationType, "equals" | "not-equals">

export const VALIDATION_TYPE_RESPONSIBLE_ATTENDANT_CONDITION_TO_NAME: Record<ResponsibleAttendantConditionType, string> = {
	equals: "Igual",
	"not-equals": "Não é igual"
}

const RESPONSIBLE_ATTENDANT_CONTEXT_VAR = "{{clientResponsibleAttendantId}}"

const ClientResponsibleAttendantInput: AvailableValidationInputValue = {
	title: "Atendente responsável",
	defaultFirstParamValue: RESPONSIBLE_ATTENDANT_CONTEXT_VAR,
	secondParam: {
		render: ({ onChangeValidationValue, value, validation, constructionResources }) => {
			const chatBotFlowConstructorStore = useChatBotFlowConstructorStore()

			if (validation.type !== "equals" && validation.type !== "not-equals") return null

			const users: AttendantUser[] = constructionResources.conditionOptions.users ?? []
			const selectedUser = users.find((user) => user.id === value)

			return (
				<SelectInput
					defaultOption={selectedUser}
					onChange={(user) => onChangeValidationValue(user?.id ?? "")}
					options={users}
					placeholder="Atendente responsável"
					getOptionSelected={(option, selected) => option.id === selected.id}
					onUpdate={async () => {
						await chatBotFlowConstructorStore.loadSpecificConstructionResources("conditionOptions")
					}}
					noOptionsText="Nenhum atendente encontrado"
				/>
			)
		}
	},
	types: ["equals", "not-equals"],
	customValidationTypeName: VALIDATION_TYPE_RESPONSIBLE_ATTENDANT_CONDITION_TO_NAME
}

export default ClientResponsibleAttendantInput
